import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Grid,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import AttendanceVeiwController from "../../redux/actions/AttendenceApiAction";
import toast from "react-hot-toast";

const MarkAttendanceModal = ({ show, handleClose, employees, onSuccess }) => {
  const dispatch = useDispatch();
  const { markManualAttendance } = AttendanceVeiwController();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("Present");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      // Default to today
      const today = new Date().toISOString().split("T")[0];
      setStartDate(today);
      setEndDate(today);
      setStatus("Present");
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      toast.error("Start Date and End Date are required");
      return;
    }
    if (new Date(endDate) < new Date(startDate)) {
      toast.error("End Date cannot be before Start Date");
      return;
    }

    setLoading(true);

    try {
      // Pass the time strings directly, backend will combine them with each date in the range
      const reqData = {
        employee_ids: employees?.map(emp => emp.id) || [],
        start_date: startDate,
        end_date: endDate,
        status: status,
      };

      await dispatch(markManualAttendance(reqData));
      if (onSuccess) {
        onSuccess();
      }
      handleClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={show} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Mark Attendance</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="textSecondary">
                Employee{employees?.length > 1 ? "s" : ""}
              </Typography>
              <Typography variant="body1">
                {employees?.length === 1
                  ? `${employees[0].first_name || ""} ${employees[0].last_name || ""} (${employees[0].employee_id})`
                  : `${employees?.length || 0} employees selected`}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Start Date"
                type="date"
                fullWidth
                required
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: new Date().toISOString().split("T")[0] }}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="End Date"
                type="date"
                fullWidth
                required
                InputLabelProps={{ shrink: true }}
                inputProps={{ max: new Date().toISOString().split("T")[0] }}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Status"
                select
                fullWidth
                required
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="Present">Present</MenuItem>
                <MenuItem value="Absent">Absent</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="inherit" disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary" disabled={loading}>
            Save
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default MarkAttendanceModal;
